/**
 * 資料請求者様限定サイトのログイン(login.html)。
 *
 * 静的HTML構成のためサーバ側で照合できず、パスワードはビルド後のJSに残る。
 * 機密情報を守る仕組みではなく、資料請求者以外の流入を抑える簡易的な閲覧制限として運用する。
 *
 * 認可フラグは sessionStorage に持たせ、limited/index.html 側の
 * ブロッキングスクリプト(src/limited/_guard.ejs)が同じキーを見る。
 * キーを変更する場合は _guard.ejs も必ず合わせること。
 */
const LIMITED_PASS = 'CAPITAL252';
const LIMITED_AUTH_KEY = 'limitedAuth';
const LIMITED_PATH = './index.html';

const MESSAGE = {
  empty: 'パスワードを入力してください。',
  unmatch: 'パスワードが正しくありません。',
  storage: 'ブラウザの設定によりログインできません。プライベートモードを解除してお試しください。'
};

export default class Login {
  constructor() {
    this.$form = document.querySelector('.js-loginForm');

    if (!this.$form) return;

    this.$input = this.$form.querySelector('.js-loginInput');
    this.$error = this.$form.querySelector('.js-loginError');

    if (!this.$input) return;

    // 認証済みで login を直接開いた場合は限定ページへ送る
    if (Login.isAuthed()) {
      window.location.replace(LIMITED_PATH);
      return;
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.clearError = this.clearError.bind(this);
    this.$form.addEventListener('submit', this.handleSubmit);
    // 打ち直しを始めた時点でエラーは引っ込める
    this.$input.addEventListener('input', this.clearError);
  }

  static isAuthed() {
    try {
      return window.sessionStorage.getItem(LIMITED_AUTH_KEY) === '1';
    } catch {
      return false;
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const value = this.$input.value.trim();

    if (value === '') {
      this.showError(MESSAGE.empty);
      return;
    }

    // 入力ミスを弾かないよう、大文字小文字は区別せず照合する
    if (value.toUpperCase() !== LIMITED_PASS.toUpperCase()) {
      this.showError(MESSAGE.unmatch);
      this.$input.select();
      return;
    }

    try {
      window.sessionStorage.setItem(LIMITED_AUTH_KEY, '1');
    } catch {
      // sessionStorage が使えないとガード側で必ず弾かれるため、遷移させず理由を出す
      this.showError(MESSAGE.storage);
      return;
    }

    window.location.href = LIMITED_PATH;
  }

  showError(message) {
    this.$input.setAttribute('aria-invalid', 'true');

    if (!this.$error) return;

    this.$error.textContent = message;
    this.$error.hidden = false;
  }

  clearError() {
    this.$input.removeAttribute('aria-invalid');

    if (!this.$error || this.$error.hidden) return;

    this.$error.textContent = '';
    this.$error.hidden = true;
  }
}
